import { Helmet } from 'react-helmet-async';

interface SchemaMarkupProps {
  type: 'Article' | 'Product' | 'Review' | 'Organization' | 'WebSite';
  data: any;
}

const SchemaMarkup = ({ type, data }: SchemaMarkupProps) => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": type,
    ...data
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
    </Helmet>
  );
};

export default SchemaMarkup; 